import { makeStyles } from "@material-ui/core/styles";
export const useStyles = makeStyles((theme) => ({
    root: {
        paddingTop: "13%",
        paddingBottom: "15%",
        flexGrow: 1,
        paddingLeft: "8%",
        paddingRight: "3%",
        backgroundColor: "#526EB5",
    },
    paper: {
        height: 250,
        width: 250,
        backgroundColor: '#F6F5F5',
        flexGrow: 1,
    },
    buttonLogin: {
        backgroundColor: "#00e676",
        color: "white",
    },
    curve: {
        position: "absolute",
        borderRadius: "100% 50%",
        width: "60%",
        height: "100%",
        backgroundColor: "#718BCB",
        zIndex: 1,
    }
}));